import React, { useEffect, useState } from 'react';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Components
import PromotionsTalbe from './promotionsTable';
import ModalAdditionalPromotions from './additionalPromotions';
import { utils } from '../../../../utils/utils';
import useCart from '../../../../hooks/orders/CartProvider';

const PromotionsModal = ({ onClose, open }) => {
    const { sale: { items, currency, ignoredPromotionIds, ignoredPromotions, additionalPromotions, notAppliedPromotions }, update, existProcessedPayment } = useCart();

    const [promotions, setPromotions] = useState();
    const [avaliables, setAvaliables] = useState([]);
    const [unavaliables, setUnavaliables] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        const promotions = utils.selectMany(items, 'promotions');
        const avaliables = utils.selectMany(promotions, 'avaliables');
        const unavaliables = notAppliedPromotions;
        setPromotions({ avaliables, unavaliables })
    }, [items])

    useEffect(() => {
        const group = (promotinos) => {
            const gb = utils.groupBy(promotinos, 'promotionId');
            
            return Object
                .keys(gb)
                .map(key => ({
                    id: key,
                    title: gb[key][0].title,
                    items: items
                        .filter(item => item.promotions.avaliables.some(p => p.promotionId === key))
                        .map(item => {
                            const itemPromotions = item.promotions.avaliables.filter(p => p.promotionId === key)
                            const totalPromoAffected = utils.sum(itemPromotions, 'promoAffected')
                            return {
                                refId: item.refId,
                                quantity: totalPromoAffected || itemPromotions.length,
                                discount: utils.sum(itemPromotions, 'discount')
                            }
                        }),
                    discount: utils.sum(gb[key], 'discount'),
                    description: gb[key][0].description
                }))
        }

        if (promotions) {
            setAvaliables(group(promotions.avaliables))
            setUnavaliables(group(promotions.unavaliables))
        }
    }, [promotions, items])

    const handlePromotionsChange = async (additionalPromotions = []) => 
        update({ 
            additionalPromotions,
            ignoredPromotionIds: ignoredPromotionIds?.filter(id => !additionalPromotions.find(p => p.id === id)) || [], 
            ignoredPromotions: ignoredPromotions?.filter(ipromo => !additionalPromotions.find(p => p.id === ipromo.id)) || []
        })

    const handlePromotionDelete = ( promotion ) => 
        update({ 
            ignoredPromotionIds: ignoredPromotionIds 
                ? [...new Set([...ignoredPromotionIds, promotion.id])]
                : [promotion.id], 
            ignoredPromotions: ignoredPromotions 
                ? [...ignoredPromotions, promotion]
                : [promotion]
        })

    const handlePromotionAdd = ( promotion ) =>
        update({ 
            ignoredPromotionIds: ignoredPromotionIds?.filter(id => promotion.id !== id) || [], 
            ignoredPromotions: ignoredPromotions?.filter(ipromo => promotion.id !== ipromo.id) || []
        })

    return (
        <>
            {
                openModal &&
                <ModalAdditionalPromotions
                    open={openModal}
                    additionalPromotions={additionalPromotions}
                    onChange={handlePromotionsChange}
                    onClose={() => setOpenModal(false)}
                />
            }
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Promociones
                </DialogTitle>
                <DialogContent style={{ minWidth: 430 }}>
                    <DialogContentText id="alert-dialog-description">
                        Desde este panel se pueden ver las promociones aplicadas y no aplicadas a la orden.
                        Los <strong>descuentos</strong> son montos que disminuyen el precio final a pagar y
                        las <strong>devoluciones</strong> son los montos que el banco devolvera a la tarjeta del comprador
                        una vez finalizada la compra.
                    </DialogContentText>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <PromotionsTalbe
                                title='Promociones aplicadas'
                                currency={currency}
                                promotions={avaliables}
                                onDelete={handlePromotionDelete}
                                disabled={existProcessedPayment}
                            />
                        </Grid>
                        {
                            !!unavaliables.length &&
                            <Grid size={12}>
                                <PromotionsTalbe
                                    title='Promociones no aplicadas'
                                    currency={currency}
                                    promotions={unavaliables}
                                    disabled={existProcessedPayment}
                                />
                            </Grid>
                        }
                        {
                            ignoredPromotions &&
                            ignoredPromotions.length > 0 &&
                            <Grid size={12}>
                                <PromotionsTalbe
                                    title='Promociones ignoradas'
                                    currency={currency}
                                    promotions={ignoredPromotions}
                                    onAdd={handlePromotionAdd}
                                    disabled={existProcessedPayment}
                                />
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpenModal(true)}
                        color="primary"
                        disabled={existProcessedPayment}
                    >
                        Promociones adicionales
                    </Button>
                    <Button
                        onClick={onClose}
                        color="primary"
                        autoFocus
                    >
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PromotionsModal;